export default __webpack_public_path__ + "eb9fd1bddd6f8bbcd49f0df4b6ed3538.svg";